import { isEmpty } from 'lodash/fp';

import logger from '../../../../logging';

// @ts-expect-error - Automatic, Please fix when editing this file
const isValidPerkNavItem = (perk) => {
  const perkItem = perk?.item;
  if (!perkItem) {
    logger.getLogger().warn('Missing perk in table of contents item used in nav header.', { perk });
    return false;
  }

  const hasNavigablePath =
    (!isEmpty(perkItem?.descriptionTeaser) && !isEmpty(perkItem?.identifier?.current)) ||
    !isEmpty(perkItem?.urlObject?.url);

  if (perkItem?.__typename === 'MemberPerk' && !isEmpty(perk?.name) && hasNavigablePath) {
    return true;
  }

  logger.getLogger().warn('Cannot build nav item from table of contents item used in nav header.', { perk });
  return false;
};

export default isValidPerkNavItem;
